import { defineNuxtPlugin } from 'nuxt/app';
import { useMainStore } from '@/stores/main';

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const store = useMainStore();
    store.clientInit();
  }
});
